<template>
  <div>
    <div class="content-8__titlebar">
      <div class="content-8__titlebar__left">
        <div class="c8-titlename">
          <span class="c8-titlename__text">{{ getLuJhuText() }}</span>
        </div>
      </div>
      <div class="content-8__titlebar__right">
        <YearPicker v-if="isHK" v-model="selectDate" />
        <DateFilterTab v-else v-model="selectDate" />
      </div>
    </div>
    <div class="content-8__controlbar">
      <div class="content-8__controlbar__item fn-content-8__controlbar__item">
        <div class="c8-explanation fn-c8-explanation" fn-hover-open>
          <div class="c8-explanation__icon"></div><span class="c8-explanation__title">说明：</span>
          <div class="c8-explanation__content">
            <p>1. 路珠图展示近期每期的开奖结果，请从左到右、自上而下查看路珠图，当连续开出的同一形态中断时，则另起一列显示</p>
            <p>2. 表格最右一列为最新一期结果</p>
          </div>
        </div>
      </div>
      <div v-if="!NoShowFilter.includes(luJhuType)" class="content-8__controlbar__item">
        <SMCheckBoxGroup
          v-model="selectFilter"
          title="筛选球位"
          :filter-data="getFilterList"
        />
      </div>
    </div>
    <NoData v-if="showLujhuInfo.length === 0 && !isLoading" />
    <div v-else v-loading="isLoading" class="content-8__content">
      <div
        v-for="(group, index) in showLujhuInfo"
        :key="index"
        class="luzhutable"
      >
        <div class="luzhutable__head">
          <div class="luzhutable__head__left">
            <div class="luzhutable-group">
              <span class="head-text">连续出现</span>
              <div class="inputbox">
                <input
                  :ref="`${group.field}-count`"
                  class="inputbox__input"
                  type="number"
                  min="0"
                  value="0"
                >
              </div>
              <span class="head-text">次以上</span>
              <div class="selectbox">
                <select :ref="`${group.field}-type`" class="selectbox__select">
                  <template v-for="(sortItem, sortIndex) in luZhuSortMapping">
                    <option
                      v-if="group.totals[sortItem.key] || isHeZero(sortItem.key)"
                      :key="`sort-${sortIndex}`"
                      :value="sortItem.key"
                    >
                      {{ sortItem.label }}
                    </option>
                  </template>
                </select>
              </div>
              <a
                class="button-primary active"
                @click.prevent="handleSortLight(group.field)"
              >
                <span class="button-primary__text">确定</span>
              </a>
            </div>
            <div class="luzhutable-group">
              <span class="head-text">出现的次数:</span>
              <span :ref="`${group.field}-${group.ruleType}-value`" class="head-text">{{ getCount(`${group.field}-${group.ruleType}`) }}</span>
            </div>
          </div>
          <div class="luzhutable__head__right">
            <div class="luzhutable-group">
              <span class="head-text">今日累计:</span>
              <template v-for="(mappingItem, sortIndex) in luZhuSortMapping">
                <span
                  v-if="group.totals[mappingItem.key]"
                  :key="`sort-${sortIndex}`"
                >
                  {{ mappingItem.label }}({{ group.totals[mappingItem.key] }})
                </span>
                <span
                  v-else-if="isHeZero(mappingItem.key)"
                  :key="`sort-${sortIndex}`"
                >
                  和(0)
                </span>
              </template>
            </div>
            <div class="luzhutable-group">
              <span class="head-text red">{{ groupName(group.field) }}</span>
              <span class="head-text red">最新↓</span>
            </div>
          </div>
        </div>
        <div class="luzhutable-scroll">
          <div :ref="`${group.field}-${group.ruleType}`" class="luzhutable__content">
            <div
              v-for="(point, pointIndex) in group.roadBeads"
              :key="`point-${pointIndex}`"
              class="luzhutable__content__item"
              :class="handleHighlight(group.field, point)"
            >
              <!-- hightlight 螢光筆的class-->
              <div class="textbox">
                <div
                  v-for="(pointItem, pointItemIndex) in point"
                  :key="`point-item-${pointItemIndex}`"
                  class="textbox__item"
                  :class="textColor(pointItem)"
                >
                  <span class="textbox__item__text">
                    {{ pointItem | itemName }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getRoadBallCount } from '@/api/desktop/roadball'
import YearPicker from '@/components/web/common/YearPicker'
import SMCheckBoxGroup from '@/components/desktop/common/SMCheckBoxGroup'
import NoData from '@/components/web/common/NoData'
import DateFilterTab from '@/components/desktop/common/DateFilterTab'

import { getLotteryType } from '~/utils/lotteryLib'

const mappingAll = {
  ZongHeDanShuang: '总和单双',
  ZongHeDaXiao: '总和大小'
}

const mappingName = (val) => {
  switch (val) {
    case 'hm1':
      return '正码一'
    case 'hm2':
      return '正码二'
    case 'hm3':
      return '正码三'
    case 'hm4':
      return '正码四'
    case 'hm5':
      return '正码五'
    case 'hm6':
      return '正码六'
    case 'tm':
      return '特码'
    case 'all':
      return mappingAll[this.luJhuType]
    default:
      console.error('错误球组名称')
      return val
  }
}

export default {
  components: {
    YearPicker,
    SMCheckBoxGroup,
    NoData,
    DateFilterTab
  },
  filters: {
    itemName(value) {
      // 过滤资料球名称
      switch (value) {
        case 'danshuang_dan':
          return '单'
        case 'danshuang_shuang':
          return '双'
        case 'daxiao_da':
          return '大'
        case 'daxiao_xiao':
          return '小'
        case 'danshuang_he':
        case 'daxiao_he':
          return '和'
        case 'yanse_lan':
          return '蓝'
        case 'yanse_lyu':
          return '绿'
        case 'yanse_hong':
          return '红'
        default:
          console.error('错误球名称')
          return value
      }
    }
  },
  props: {
    luJhuType: {
      required: true,
      type: String,
      default: () => {
        return ''
      }
    }
  },
  data() {
    return {
      data: [],
      lotteryType: '',
      selectFilter: [],
      selectRadio: '',
      selectDate: '30',
      show: {
        filter: false,
        type: false
      },
      isLoading: false,
      hightlightObj: {},
      getFilterList: [
        { name: '正码一', val: 'hm1' },
        { name: '正码二', val: 'hm2' },
        { name: '正码三', val: 'hm3' },
        { name: '正码四', val: 'hm4' },
        { name: '正码五', val: 'hm5' },
        { name: '正码六', val: 'hm6' },
        { name: '特码', val: 'tm' }
      ],
      luZhuSortMapping: [
        { key: 'daxiao_da', label: '大' },
        { key: 'daxiao_xiao', label: '小' },
        { key: 'yanse_hong', label: '红' },
        { key: 'yanse_lyu', label: '绿' },
        { key: 'yanse_lan', label: '蓝' },
        { key: 'danshuang_dan', label: '单' },
        { key: 'danshuang_shuang', label: '双' },
        { key: 'danshuang_he', label: '和' },
        { key: 'daxiao_he', label: '和' }
      ],
      NoShowFilter: [
        'ZongHeDaXiaoLuJhu',
        'ZongHeDanShuangLuJhu'
      ]
    }
  },
  computed: {
    isHK() {
      return this.$route.params.lottery_code === 'hk6'
    },
    showLujhuInfo() {
      // 通过筛选条件要显示出来的资料
      switch (this.luJhuType) {
        case 'BoSeLuJhu':
        case 'DanShuangLuJhu':
        case 'DaXaioLuJhu':
        case 'WeiShuDaXiaoLuJhu':
        case 'HeShuDanShuangLuJhu':
          return this.data.filter((e) => this.selectFilter.includes(e.field))
        case 'ZongHeDanShuangLuJhu':
        case 'ZongHeDaXiaoLuJhu':
          return this.data.filter((e) => e.field === 'all')
        default:
          return ''
      }
    },
    isZongHe() {
      return ['ZongHeDanShuangLuJhu', 'ZongHeDaXiaoLuJhu'].includes(
        this.luJhuType
      )
    }
  },
  watch: {
    selectDate(newValue) {
      this.getInfo(newValue)
    },
    selectFilter() {
      this.initHightlightObj(this.data)
    }
  },
  created() {
    this.lotteryType = getLotteryType(this.$route.params.lottery_code)
    this.selectFilter = ['hm1', 'hm2', 'hm3', 'hm4', 'hm5', 'hm6', 'tm']
  },
  mounted() {
    if (this.isHK) {
      this.selectDate = `${new Date().getFullYear()}`
      this.getInfo(this.selectDate)
    } else {
      this.getInfo('30')
    }
  },
  methods: {
    async getInfo(query) {
      this.isLoading = true
      let rules
      switch (this.luJhuType) {
        case 'BoSeLuJhu':
          rules = 'seBo'
          break
        case 'DanShuangLuJhu':
          rules = 'hmDanShuang'
          break
        case 'DaXaioLuJhu':
          rules = 'hmDaXiao'
          break
        case 'ZongHeDanShuangLuJhu':
          rules = 'zongHeDanShuang'
          break
        case 'ZongHeDaXiaoLuJhu':
          rules = 'zongHeDaXiao'
          break
        case 'WeiShuDaXiaoLuJhu':
          rules = 'hmWeiShuDaXiao'
          break
        case 'HeShuDanShuangLuJhu':
          rules = 'hmHeDanShuang'
          break
        default:
          console.error('错误路珠名称')
          rules = ''
      }

      const queryObj = {}
      // 期數 count
      if (/^\d{2}$/.test(query)) {
        queryObj.count = query
      } else if (/^\d{4}$/.test(query)) {
        // 香港六和 year
        queryObj.year = query
      } else {
        // 一般 date
        queryObj.date = query
      }

      const [data, error] = await getRoadBallCount({
        ...queryObj,
        rules,
        code: this.$route.params.lottery_code
      })
      this.isLoading = false
      if (error) {
        console.error(`[error]:`, error)
        return
      }

      this.initHightlightObj(data)

      this.data = data
    },
    // 判斷是否要顯示 和(0)
    isHeZero(openType) {
      const hasDSHeType = ['DanShuangLuJhu', 'HeShuDanShuangLuJhu']
      const hasDXHeType = ['DaXaioLuJhu', 'WeiShuDaXiaoLuJhu']
      // 單雙和
      if (openType === 'danshuang_he' && hasDSHeType.includes(this.luJhuType)) {
        return true
      }
      // 大小和
      if (openType === 'daxiao_he' && hasDXHeType.includes(this.luJhuType)) {
        return true
      }
      return false
    },
    doChange(val) {
      if (val === 'second') {
        this.show.type = true
      } else {
        this.show.filter = true
      }
    },
    textColor(val) {
      // 球区分颜色
      switch (val) {
        case 'daxiao_da':
        case 'danshuang_shuang':
        case 'yanse_hong':
          return 'red'
        case 'yanse_lan':
          return 'blue'
        case 'yanse_lyu':
          return 'green'
        default:
          return ''
      }
    },
    groupName(val) {
      // 根据不同彩种的球分组名字转换
      switch (this.luJhuType) {
        case 'BoSeLuJhu':
        case 'DanShuangLuJhu':
        case 'DaXaioLuJhu':
          return mappingName(val)
        case 'ZongHeDanShuangLuJhu':
        case 'ZongHeDaXiaoLuJhu':
          return mappingAll[this.luJhuType]
        case 'WeiShuDaXiaoLuJhu':
          return mappingName(val) + '尾数大小'
        case 'HeShuDanShuangLuJhu':
          return mappingName(val) + '合数单双'
        default:
          console.error('错误路珠名称')
          return ''
      }
    },
    getLuJhuText() {
      switch (this.luJhuType) {
        case 'BoSeLuJhu':
          return '波色路珠'
        case 'DanShuangLuJhu':
          return '单双路珠'
        case 'DaXaioLuJhu':
          return '大小路珠'
        case 'ZongHeDanShuangLuJhu':
          return '总和单双路珠'
        case 'ZongHeDaXiaoLuJhu':
          return '总和大小路珠'
        case 'WeiShuDaXiaoLuJhu':
          return '尾数大小路珠'
        case 'HeShuDanShuangLuJhu':
          return '合数单双路珠'
        default:
          console.error('错误路珠名称')
          return ''
      }
    },
    handleHighlight(ball, point) {
      if (
        point.length >= Number(this.hightlightObj[ball].split('-')[0]) &&
        point[0] === this.hightlightObj[ball].split('-')[1]
      ) {
        return 'hightlight'
      }
    },
    handleSortLight(ball) {
      const count = `${ball}-count`
      const type = `${ball}-type`
      this.hightlightObj = Object.assign(this.hightlightObj, {
        [ball]: `${this.$refs[count][0].value}-${this.$refs[type][0].value}`
      })
    },
    // 計算 Hightlight 數量
    getCount(name) {
      this.$nextTick(() => {
        if (this.$refs[name]) {
          const childrenNodes = Array.from(this.$refs[name][0].children)
          const highLightItems = childrenNodes.filter((node) => {
            return node.className.includes('hightlight')
          })
          this.$refs[`${name}-value`][0].innerHTML = highLightItems.length
        } else {
          return 0
        }
      })
    },
    // 重置 Hightlight 注意[type.field] or [type.ruleType]
    initHightlightObj(data) {
      const hightLightInitObj = {}
      data.forEach((type) => {
        hightLightInitObj[type.field] = ''
      })
      this.hightlightObj = hightLightInitObj
    }
  }
}
</script>

<style lang="scss">
[fn-hover-open]:hover {
  height: auto;
  z-index: 999;
}
.fn-content-8__controlbar__item {
  position: relative;
  min-height: 49px;
}
.fn-c8-explanation {
  position: absolute;
  z-index: 10;
  width: calc(100% - 32px);
}
//for 路珠 最新一期的珠子 一閃一閃
@keyframes fade {
  from {
    opacity: 1.0;
  }
  50% {
    opacity: 0.4;
  }
  to {
      opacity: 1.0;
  }
}
.content-8 {
  & /deep/ {
    .luzhutable__content__item {
      &:nth-child(1) {
        .textbox__item {
          &:nth-last-child(1) {
            .textbox__item__text{
              font-size: 15px;
              height: 60px;
              animation: fade 600ms infinite;
            }
          }
        }
      }
    }
  }
}
</style>
